import i18n from '@/plugins/i18n'
import { Phone } from '@/types'
import { isArray } from 'lodash'

export type FieldRule = (v: string) => string | true

export function maxLengthGenerator(max: number) {
  return (v: string): string | true => !v || v.length <= max || i18n.t('form.error.max_length', { c: max }) as string
}

export function isRequiredGenerator(message: string) {
  return (v: string): string | true => !!v || message
}

export const isRequired = isRequiredGenerator(i18n.t('rules.required').toString())

export function isPositiveNumber(v: number | string): true | string {
  return (v >= 0 && /^(?:\d+|\d*\.\d+)$/.test(v.toString())) || i18n.t('rules.positive_number').toString()
}

export function arePositiveIntegers(v: string | number | (number | string)[]): true | string {
  const nv = isArray(v) ? v : [v]
  return nv.every(w => Number(w) >= 0) || i18n.t('rules.positive_integers').toString()
}

export function isPercentage(v: number): true | string {
  return v >= 0 && v <= 100 || i18n.t('rules.percentage').toString()
}

export function atLeastOneSelectionGenerator(messageError: string) {
  return (v: unknown[]): string | true => v.length > 0 || messageError
}

export function isYear(v: number): true | string {
  return !v || (arePositiveIntegers(v) && v.toString().length === 4) || i18n.t('rules.year').toString()
}

export function validSireIdRule(v: string): boolean | string {
  return !v || v.match('^\\d{8}[A-Z]$') != null || i18n.t('rules.horse.sire_invalid').toString()
}

export function validMicrochipIdRule(v: string): string | true {
  return !v || v.match('^\\d{15}$') != null || i18n.t('rules.horse.microchip_invalid').toString()
}

export function rulePasswordNumber(v: string): string | true {
  return !v || /[0-9]/.test(v) || i18n.t('rules.password.number').toString()
}

export function rulePasswordLowerCase(v: string): string | true {
  return !v || /[a-z]/.test(v) || i18n.t('rules.password.lower_case').toString()
}

export function rulePasswordUpperCase(v: string): string | true {
  return !v || /[A-Z]/.test(v) || i18n.t('rules.password.upper_case').toString()
}

export function rulePasswordSpecialCase(v: string): string | true {
  return !v || /[[\]$&+,:;=?@#|'<>.\-^*()%!]/.test(v) || i18n.t('rules.password.special_case').toString()
}

export function rulePasswordEightCharactersLong(v: string): string | true {
  return !v || v.length >= 8 || i18n.t('rules.password.eight').toString()
}

export function ruleRequired(v: string): string | true {
  return !!v || i18n.t('rules.password.required').toString()
}

export function rulePhoneValidGenerator(v: string): (p: Phone) => boolean|string {
  return (phone) => phone.valid || (phone.valid === undefined && phone.number?.length > 0) || v
}

export const rulePassword: FieldRule[] = [
  rulePasswordNumber,
  rulePasswordLowerCase,
  rulePasswordUpperCase,
  rulePasswordSpecialCase,
  rulePasswordEightCharactersLong,
]

export default { isRequired, arePositiveIntegers, isPositiveNumber, isPercentage, atLeastOneSelectionGenerator, isYear }
